/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FindOrCreateUserRequest
 */
export interface FindOrCreateUserRequest {
  /**
   *
   * @type {string}
   * @memberof FindOrCreateUserRequest
   */
  email: string
  /**
   * Телефон в формате +7XXXXXXXXXX
   * @type {string}
   * @memberof FindOrCreateUserRequest
   */
  phone?: string | null
  /**
   *
   * @type {string}
   * @memberof FindOrCreateUserRequest
   */
  firstName?: string | null
  /**
   *
   * @type {string}
   * @memberof FindOrCreateUserRequest
   */
  lastName?: string | null
}

/**
 * Check if a given object implements the FindOrCreateUserRequest interface.
 */
export function instanceOfFindOrCreateUserRequest(
  value: object
): value is FindOrCreateUserRequest {
  if (!('email' in value) || value['email'] === undefined) return false
  return true
}

export function FindOrCreateUserRequestFromJSON(
  json: any
): FindOrCreateUserRequest {
  return FindOrCreateUserRequestFromJSONTyped(json, false)
}

export function FindOrCreateUserRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FindOrCreateUserRequest {
  if (json == null) {
    return json
  }
  return {
    email: json['email'],
    phone: json['phone'] == null ? undefined : json['phone'],
    firstName: json['firstName'] == null ? undefined : json['firstName'],
    lastName: json['lastName'] == null ? undefined : json['lastName'],
  }
}

export function FindOrCreateUserRequestToJSON(
  value?: FindOrCreateUserRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    email: value['email'],
    phone: value['phone'],
    firstName: value['firstName'],
    lastName: value['lastName'],
  }
}
